import { apiConstants } from '../../apiConstant'
import { formDataCommonFunction } from '../../serviceCall'

export const getCheckupReportApi = (data, callback, errorCallBack) => {
    return async (dispatch) => {
        formDataCommonFunction(data, apiConstants.HOME_MAINTENANCE.GET_CHECKUP_REPORT)
            .then((response) => {
                callback && callback(response.data)
            })
            .catch((error) => {
                errorCallBack && errorCallBack(error.response)
            })
    }
}
